module.exports = __webpack_public_path__ + "img/paradox-leader.8d617e21.png";